/** Wraps `sessionStorage` access in try/catch since it can throw (e.g. private browsing, storage disabled/full). */
export function safeSessionStorageGetItem(key: string): string | null {
  try {
    return sessionStorage.getItem(key);
  } catch {
    return null;
  }
}

export function safeSessionStorageSetItem(key: string, value: string): void {
  try {
    sessionStorage.setItem(key, value);
  } catch (error) {
    console.warn(`Failed to set sessionStorage item "${key}"`, error);
  }
}

export function safeSessionStorageRemoveItem(key: string): void {
  try {
    sessionStorage.removeItem(key);
  } catch (error) {
    console.warn(`Failed to remove sessionStorage item "${key}"`, error);
  }
}
